const alphaLangOrder: { [key: string]: { keyOrder: string[] } } = {
  en: {
    keyOrder: [
      '#',
      'A',
      'B',
      'C',
      'D',
      'E',
      'F',
      'G',
      'H',
      'I',
      'J',
      'K',
      'L',
      'M',
      'N',
      'O',
      'P',
      'Q',
      'R',
      'S',
      'T',
      'U',
      'V',
      'W',
      'X',
      'Y',
      'Z',
    ],
  },

  da: {
    keyOrder: [
      '#',
      'A',
      'Å',
      'Æ',
      'B',
      'C',
      'D',
      'E',
      'F',
      'G',
      'H',
      'I',
      'J',
      'K',
      'L',
      'M',
      'N',
      'O',
      'Ø',
      'P',
      'Q',
      'R',
      'S',
      'T',
      'U',
      'V',
      'W',
      'X',
      'Y',
      'Z',
    ],
  },

  es: {
    keyOrder: [
      '#',
      'A',
      'Á',
      'B',
      'C',
      'D',
      'E',
      'F',
      'G',
      'H',
      'I',
      'J',
      'K',
      'L',
      'M',
      'N',
      'Ñ',
      'O',
      'P',
      'Q',
      'R',
      'S',
      'T',
      'U',
      'V',
      'W',
      'X',
      'Y',
      'Z',
    ],
  },

  fr: {
    keyOrder: [
      '#',
      'A',
      'B',
      'C',
      'D',
      'E',
      'F',
      'G',
      'H',
      'I',
      'J',
      'K',
      'L',
      'M',
      'N',
      'O',
      'P',
      'Q',
      'R',
      'S',
      'T',
      'U',
      'V',
      'W',
      'X',
      'Y',
      'Z',
    ],
  },

  hu: {
    keyOrder: [
      '#',
      'A',
      'Á',
      'B',
      'C',
      'Cs',
      'D',
      'E',
      'É',
      'F',
      'G',
      'Gy',
      'H',
      'I',
      'Í',
      'J',
      'K',
      'L',
      'Ly',
      'M',
      'N',
      'Ny',
      'O',
      'Ó',
      'Ö',
      'Ő',
      'P',
      'R',
      'S',
      'Sz',
      'T',
      'Ty',
      'U',
      'Ú',
      'Ü',
      'Ű',
      'V',
      'W',
      'X',
      'Y',
      'Z',
      'Zs',
    ],
  },

  id: {
    keyOrder: [
      '#',
      'A',
      'B',
      'C',
      'D',
      'E',
      'F',
      'G',
      'H',
      'I',
      'J',
      'K',
      'L',
      'M',
      'N',
      'O',
      'P',
      'Q',
      'R',
      'S',
      'T',
      'U',
      'V',
      'W',
      'X',
      'Y',
      'Z',
    ],
  },

  it: {
    keyOrder: [
      '#',
      'A',
      'B',
      'C',
      'D',
      'E',
      'F',
      'G',
      'H',
      'I',
      'J',
      'K',
      'L',
      'M',
      'N',
      'O',
      'P',
      'Q',
      'R',
      'S',
      'T',
      'U',
      'V',
      'W',
      'X',
      'Y',
      'Z',
    ],
  },

  pl: {
    keyOrder: [
      '#',
      'A',
      'Ą',
      'B',
      'C',
      'Ć',
      'D',
      'E',
      'Ę',
      'F',
      'G',
      'H',
      'I',
      'J',
      'K',
      'L',
      'Ł',
      'M',
      'N',
      'Ń',
      'O',
      'Ó',
      'P',
      'R',
      'S',
      'Ś',
      'T',
      'U',
      'V',
      'W',
      'X',
      'Y',
      'Z',
      'Ź',
      'Ż',
    ],
  },

  pt: {
    keyOrder: [
      '#',
      'A',
      'Á',
      'B',
      'C',
      'D',
      'E',
      'F',
      'G',
      'H',
      'I',
      'J',
      'K',
      'L',
      'M',
      'N',
      'O',
      'P',
      'Q',
      'R',
      'S',
      'T',
      'U',
      'V',
      'W',
      'X',
      'Y',
      'Z',
    ],
  },
  'pt-BR': {
    keyOrder: [
      '#',
      'A',
      'Á',
      'B',
      'C',
      'D',
      'E',
      'F',
      'G',
      'H',
      'I',
      'J',
      'K',
      'L',
      'M',
      'N',
      'O',
      'P',
      'Q',
      'R',
      'S',
      'T',
      'U',
      'V',
      'W',
      'X',
      'Y',
      'Z',
    ],
  },

  ro: {
    keyOrder: [
      '#',
      'A',
      'Ă',
      'Â',
      'B',
      'C',
      'D',
      'E',
      'F',
      'G',
      'H',
      'I',
      'Î',
      'J',
      'K',
      'L',
      'M',
      'N',
      'O',
      'P',
      'Q',
      'R',
      'S',
      'Ș',
      'T',
      'Ț',
      'U',
      'V',
      'W',
      'X',
      'Y',
      'Z',
    ],
  },

  ru: {
    keyOrder: [
      '#',
      'А',
      'Б',
      'В',
      'Г',
      'Д',
      'Е',
      'Ё',
      'Ж',
      'З',
      'И',
      'Й',
      'К',
      'Л',
      'М',
      'Н',
      'О',
      'П',
      'Р',
      'С',
      'Т',
      'У',
      'Ф',
      'Х',
      'Ц',
      'Ч',
      'Ш',
      'Щ',
      'Ъ',
      'Ы',
      'Ь',
      'Э',
      'Ю',
      'Я',
    ],
  },

  tr: {
    keyOrder: [
      '#',
      'A',
      'B',
      'C',
      'Ç',
      'D',
      'E',
      'F',
      'G',
      'Ğ',
      'H',
      'I',
      'İ',
      'J',
      'K',
      'L',
      'M',
      'N',
      'O',
      'Ö',
      'P',
      'R',
      'S',
      'Ş',
      'T',
      'U',
      'Ü',
      'V',
      'Y',
      'Z',
    ],
  },

  vi: {
    keyOrder: [
      '#',
      'A',
      'Ă',
      'Â',
      'B',
      'C',
      'D',
      'Đ',
      'E',
      'Ê',
      'G',
      'H',
      'I',
      'K',
      'L',
      'M',
      'N',
      'O',
      'Ô',
      'Ơ',
      'P',
      'Q',
      'R',
      'S',
      'T',
      'U',
      'Ư',
      'V',
      'X',
      'Y',
    ],
  },

  'zh-HK': {
    keyOrder: [
      '#',
      'A',
      'B',
      'C',
      'D',
      'E',
      'F',
      'G',
      'H',
      'I',
      'J',
      'K',
      'L',
      'M',
      'N',
      'O',
      'P',
      'Q',
      'R',
      'S',
      'T',
      'U',
      'V',
      'W',
      'X',
      'Y',
      'Z',
    ],
  },

  ko: {
    keyOrder: [
      '#',
      'ㄱ',
      'ㄴ',
      'ㄷ',
      'ㄹ',
      'ㅁ',
      'ㅂ',
      'ㅅ',
      'ㅇ',
      'ㅈ',
      'ㅊ',
      'ㅋ',
      'ㅌ',
      'ㅍ',
      'ㅎ',
      'A',
      'B',
      'C',
      'D',
      'E',
      'F',
      'G',
      'H',
      'I',
      'J',
      'K',
      'L',
      'M',
      'N',
      'O',
      'P',
      'Q',
      'R',
      'S',
      'T',
      'U',
      'V',
      'W',
      'X',
      'Y',
      'Z',
    ],
  },
}

export default alphaLangOrder
